function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-close-x_svg__a{fill:none;stroke:#bebdbd;stroke-miterlimit:10;stroke-width:2px}"));

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  className: "icon-close-x_svg__a",
  d: "M.71.71l20 20M20.71.71l-20 20"
});

var SvgIconCloseX = function SvgIconCloseX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21.41 21.41"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMS40MSAyMS40MSI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5hIHsKICAgICAgICBmaWxsOiBub25lOwogICAgICAgIHN0cm9rZTogI2JlYmRiZDsKICAgICAgICBzdHJva2UtbWl0ZXJsaW1pdDogMTA7CiAgICAgICAgc3Ryb2tlLXdpZHRoOiAycHg7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDx0aXRsZT5DbG9zZTwvdGl0bGU+CiAgPGc+CiAgICA8bGluZSBjbGFzcz0iYSIgeDE9IjAuNzEiIHkxPSIwLjcxIiB4Mj0iMjAuNzEiIHkyPSIyMC43MSIvPgogICAgPGxpbmUgY2xhc3M9ImEiIHgxPSIyMC43MSIgeTE9IjAuNzEiIHgyPSIwLjcxIiB5Mj0iMjAuNzEiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgIconCloseX as ReactComponent };